import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import PaymentContainer from '../components/payments/PaymentContainer'
import FooterSection from '../components/FooterSection'
import styled from 'styled-components'

const Payments = () => {

  return (
    <Wrapper>
        <Navbar/>
        <PaymentContainer />
        {/**<FooterSection />**/}
    </Wrapper>
  )
}

const Wrapper = styled.div`
`

export default Payments
